import {RoomType} from '@shared/core';

export const getRoomType = (type: RoomType, t) => {
  switch (type) {
    case 'Coworking room type':
      return t('rooms.coworking');
    case 'Meeting room type':
      return t('rooms.meeting');
    case 'Office room type':
      return t('rooms.office');
    case 'Kitchen':
      return t('rooms.kitchen');
    case 'Water closet':
      return t('rooms.toilet');
    case 'Hall':
      return t('rooms.hall');
    case 'Playroom':
      return t('rooms.playroom');
    case 'Other':
      return t('rooms.other');
  }
};
